<div class="status-wrapper">
  <div *ngIf="sync || bhs_imageSync || mws_imageSync" class="synchronized">Not Changed</div>
  <div *ngIf="changed && !!delete" class="changed">Will be removed</div>
  <div *ngIf="changed && !delete" class="changed">Changed</div>
  <div *ngIf="waitingApproval && !successfullyDeleted" class="changed">Waiting Approval</div>
  <div *ngIf="confirmed" class="confirmed">Confirmed</div>
  <div *ngIf="conflict" class="conflict">Conflict</div>
  <div *ngIf="disapproved" class="disapproved">Disapproved</div>
  <div *ngIf="pendingSync && successfullyDeleted === false" class="pending-sync">Pending Sync</div>
  <div *ngIf="successfullyDeleted" class="pending-sync">Deleted</div>
  <div *ngIf="syncInProgress" class="synchronization">Synchronization</div>
  <!--  <div *ngIf="delete" class="synchronization">For Removing</div>-->
  <div *ngIf="syncError" class="shopify-sync-error" [matTooltip]="syncErrorMessage + ' ' + mws_syncErrorMessage">Sync Error</div>

  <!--  <div *ngIf="edited" class="editor">{{editorName}}</div>-->

  <span *ngIf="bhs_imageSync" class="status-badge__new"><mat-icon aria-hidden="false" fontIcon="image"></mat-icon></span>
  <span *ngIf="mws_imageSync" class="status-badge__new"><mat-icon aria-hidden="false" fontIcon="image"></mat-icon></span>
  <span *ngIf="new" [matTooltip]="'BHS'" class="status-badge__new"><mat-icon aria-hidden="false" fontIcon="fiber_new"></mat-icon></span>
  <span *ngIf="mws_new" [matTooltip]="'MWS'" class="status-badge__mws-new"><mat-icon aria-hidden="false" fontIcon="fiber_new"></mat-icon></span>
  <span *ngIf="delete" class="status-badge__delete"><mat-icon aria-hidden="false" fontIcon="delete"></mat-icon></span>
  <!--  <span *ngIf="edited" class="status-badge__edited"><mat-icon aria-hidden="false" fontIcon="edit"></mat-icon></span>-->
</div>
